import React, { useEffect } from "react";
import Main from "../src/components/Main";
import Aboutus from "../src/components/Aboutus";
import TwitterSearch from "../src/components/TwitterSearch";
import CovidResources from "../src/components/CovidResources";
import ContactUs from "../src/components/ContactUs";
import Resources from "../src/components/Resources";

import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import Donate from "./components/Donate";

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <Switch>
          <Route exact path="/">
            <Main />
          </Route>
          <Route exact path="/aboutus">
            <Aboutus />
          </Route>
          <Route exact path="/twittersearch">
            <TwitterSearch />
          </Route>
          <Route exact path="/covid19">
            <CovidResources />
          </Route>
          <Route exact path="/contact">
            <ContactUs />
          </Route>
          <Route exact path="/resources">
            <Resources />
          </Route>
          <Route exact path="/donate">
            <Donate />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}
